import Big from 'big.js';
import { useState, useContext, useEffect, useRef, useCallback } from 'react';
import { CollectionView } from '@grapecity/wijmo';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import { CellType, KeyAction, DataMap, CellRange } from '@grapecity/wijmo.grid';

import '@grapecity/wijmo.styles/wijmo.css';

// react-bootstrap components
import { ButtonGroup, Button, Card, Form, Row, Col } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useRestApi } from 'context/RestApiContext';
import { useMaster } from 'context/MasterContext';

import { MessageModal } from 'components/modal/MessageModal';
import TextComponent from 'components/Input/TextComponent';
import SelectComponent from 'components/Input/SelectComponent';
import IconButtonCompnent from 'components/Input/IconButtonCompnent';
import { ColorPickerModal } from 'components/modal/ColorPickerModal';

import { toFloat, toInt, calcTax } from 'utils/numberUtils';
import { KoujihiPersent } from 'constants/constants';

function QuoteBaseModal(props) {
  const restApi = useRestApi();
  const master = useMaster();

  const flexGrid = useRef();


  const baseGridRef = useRef(null); // 上のグリッド
  const suppressNextClickRef = useRef(false);

  // 参考価格チェックボックス
  const referencePriceCheckBox = useRef();

  // パーセント表示のマッピング
  const createPersentMap = () => {
    const map = new DataMap(KoujihiPersent, 'id', 'name');
    map.getDisplayValues = (dataItem) => {
      const validCities = KoujihiPersent.filter((p) => p.KOUJI_TYPE === dataItem.KOUJI_TYPE);
      return validCities.map((p) => p.name);
    };
    return map;
  };
  const persentMap = createPersentMap();

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 見積基盤全データ
  const [baseQuotes, setBaseQuotes] = useState({});
  // 工事種類一覧
  const [kojiSyuList, setKojiSyuList] = useState([]);

  // 選択中の工事種別（見積基盤）
  const [selectedKojiSyu, setSelectedKojiSyu] = useState('');
  // 選択中の工事種別の見積基盤データ
  const [selectedKojiSyuBaseQuotes] = useState(new CollectionView([]));

  // 確定ボタンの活性状態
  const [isFixButtonDisabled, setIsFixButtonDisabled] = useState(true);

  // 見積区分情報
  const [quoteKbn, setQuoteKbn] = useState({});

  // 登録明細
  const [editDetails] = useState(new CollectionView([]));

  // 選択中の見積もり明細
  const [selectedRow, setSelectedRow] = useState(-1);

  // 合計表示モード(detail:明細別、all:全体)
  const [totalMode, setTotalMode] = useState('detail');

  // 追加請求かどうか？
  const [isAddInvoice, setAddInvoice] = useState(false);

  // 合計（全体）
  const [total] = useState(new CollectionView([]));
  // 合計（明細別）
  const [subTotal] = useState(new CollectionView([]));

  // グルーピング処理
  const groupBy = (array, getKey) =>
    array.reduce((obj, cur, idx, src) => {
      const key = getKey(cur, idx, src);
      (obj[key] || (obj[key] = [])).push(cur);
      return obj;
    }, {});

  // 初期表示
  useEffect(() => {
    // 見積基盤の全データを取得
    restApi.get('/api/baseQuote/list', (data) => {
      // 工事種別毎の連想配列に変換に変換
      const _baseQuotes = groupBy(data, (d) => d['KOUJI_SYU']);
      setBaseQuotes(_baseQuotes);
    });
  }, []);

  // 明細データの変更イベントを監視
  useEffect(() => {
    const onCollectionChanged = () => {
      setIsFixButtonDisabled(editDetails.isEmpty); // データが空かどうかを更新
    };
    // イベントリスナーを追加
    editDetails.collectionChanged.addHandler(onCollectionChanged);
    // クリーンアップ（コンポーネントがアンマウントされた際にリスナーを削除）
    return () => {
      editDetails.collectionChanged.removeHandler(onCollectionChanged);
    };
  }, [editDetails]);

  // 工事種別の変更処理
  useEffect(() => {
    if (selectedKojiSyu) {
      // 選択中の工事種のみ表示
      let _baseQuotes = [];
      if (selectedKojiSyu in baseQuotes) {
        _baseQuotes = baseQuotes[selectedKojiSyu].map((x) => ({
          ...x,
          KINGAKU: 0,
        }));
      }
      selectedKojiSyuBaseQuotes.sourceCollection = _baseQuotes;
      selectedKojiSyuBaseQuotes.refresh();
    }
  }, [selectedKojiSyu]);

  // モーダルを表示時の処理
  useEffect(() => {
    if (props.show) {
      // 明細を未選択状態に
      setSelectedRow(-1);

      // 追加請求かどうか？
      setAddInvoice(props.paramBaseQuote.isAddInvoice);

      // 追加モードの場合
      if (props.paramBaseQuote.Mode == 'add') {
        // 工事種別一覧を取得
        const _kojiSyuList = master.kojiSyu.map((x) => x.name);
        setKojiSyuList(_kojiSyuList);

        // 見積区分情報を生成
        setQuoteKbn({
          QUOTE_KNO: props.paramBaseQuote.QUOTE_KNO,
          SIYOU: '',
          BIKO: '',
          AREA: '',
          BIKO_COLOR: '#000000',
          KOUJI_DISPLAY_NAME: _kojiSyuList.length ? _kojiSyuList[0] : '',
        });

        // 工事種別を選択
        setSelectedKojiSyu(_kojiSyuList[0]);

        // クリア
        editDetails.sourceCollection = [];
        calcTotal(false);
      }
      // 編集モードの場合
      else {
        // 見積区分情報を設定
        setQuoteKbn(props.paramBaseQuote.quoteKbn);
        // 工事種一覧
        setKojiSyuList(master.kojiSyu.map((x) => x.name));
        // 選択された工事を設定
        setSelectedKojiSyu(props.paramBaseQuote.TargetKojiSyu);
        // 編集中の明細を設定
        editDetails.sourceCollection = [...props.paramBaseQuote.Details].map((x) => ({ ...x }));
        // 合計を計算
        calcTotal(props.paramBaseQuote.quoteKbn.REFERNCE_PRICE == 1);
      }
    }
  }, [props.show]);

  // 合計の計算処理
  const calcTotal = (referencePrice) => {
    // 工事費（タイプが1:通常の金額の合計）
    let koujihi = editDetails.items
      .filter((x) => x['KOUJI_TYPE'] == 1)
      .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    // 運搬諸経費を計算
    editDetails.items
      .filter((x) => x['KOUJI_TYPE'] == 2 && x.KOUJIHI_PER < 100) // 2:運搬諸経費
      .forEach((x) => {
        // 工事費のパーセント
        let koujihiper = toFloat((koujihi * x.KOUJIHI_PER) / 100, 0);
        const idx = editDetails.items.indexOf(x);
        Object.assign(editDetails.items[idx], { ...x, TANKA: koujihiper, KINGAKU: koujihiper });
      });

    // 工事費（タイプが1:通常と2:運搬費の金額の合計）
    const otherKujihi = props.paramBaseQuote.otherQuoteDetails
      .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
      .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    koujihi =
      editDetails.items
        .filter((x) => x['KOUJI_TYPE'] == 1 || x['KOUJI_TYPE'] == 2)
        .reduce((a, x) => a + toFloat(x['KINGAKU']), 0) + otherKujihi;

    // 工事費の1～3パーセントのレコードを更新
    editDetails.items
      .filter((x) => x['KOUJI_TYPE'] == 3 && x.KOUJIHI_PER < 100) // 2:工事費の1～3パーセント
      .forEach((x) => {
        // 工事費のパーセント
        let koujihiper = toFloat((koujihi * x.KOUJIHI_PER) / 100, 0);
        const idx = editDetails.items.indexOf(x);
        Object.assign(editDetails.items[idx], { ...x, TANKA: koujihiper, KINGAKU: koujihiper });
      });

    // 工事費の全体パーセントの合計
    let kojihi_per_total =
      editDetails.items
        .filter((x) => x['KOUJI_TYPE'] == 3 && x.KOUJIHI_PER < 100)
        .reduce((a, x) => a + toFloat(x['KINGAKU']), 0) +
      props.paramBaseQuote.otherQuoteDetails
        .filter((x) => x['KOUJI_TYPE'] == 3 && x.KOUJIHI_PER < 100)
        .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    // 小計
    let shokei = referencePrice ? props.paramBaseQuote.shokei : koujihi + kojihi_per_total;
    // 値引き
    let nebiki = props.paramBaseQuote.nebiki;
    // 税抜き額
    let zeinuki = shokei + nebiki;
    // 消費税端数処理
    let tax = calcTax(zeinuki);
    // 請求額
    let seikyu = zeinuki + tax;
    // 原価合計
    let genka_kingaku = referencePrice
      ? props.paramBaseQuote.genkaKei
      : editDetails.items.reduce((a, x) => a + toFloat(x['GENKA_KINGAKU']), 0) +
      props.paramBaseQuote.genkaKei;

    // 粗利
    let arari = zeinuki - genka_kingaku;
    // 粗利率
    let arariritu = arari / zeinuki;

    // 集計結果を反映
    total.sourceCollection = [
      {
        Koujihi: referencePrice ? otherKujihi : koujihi,
        ShoKei: shokei,
        Nebiki: nebiki,
        Zeinuki: zeinuki,
        ZeiKei: tax,
        SeikyuKei: seikyu,
        GenkaKei: genka_kingaku,
        ArariKei: arari,
        RiekiRitsu: !isNaN(arariritu) ? arariritu : 0,
      },
    ];
    total.refresh();

    // 明細別の合計を計算
    calcSubTotal(editDetails.items);

    // 一覧を再描画
    editDetails.refresh();
  };

  // 明細別の合計の計算処理
  const calcSubTotal = (details) => {
    // 工事費（タイプが1:通常の金額の合計）
    let koujihi = details
      .filter((x) => x['KOUJI_TYPE'] == 1)
      .reduce((a, x) => a + toFloat(x['KINGAKU']), 0);

    // 小計
    let shokei = details.reduce((a, x) => a + toFloat(x['KINGAKU']), 0);
    // 消費税端数処理
    let tax = calcTax(shokei);
    // 請求額
    let seikyu = shokei + tax;
    // 原価合計
    let genka_kingaku = details.reduce((a, x) => a + toFloat(x['GENKA_KINGAKU']), 0);
    // 粗利
    let arari = shokei - genka_kingaku;
    // 粗利率
    let arariritu = arari / shokei;

    // 集計結果を反映
    subTotal.sourceCollection = [
      {
        Koujihi: koujihi,
        ShoKei: shokei,
        ZeiKei: tax,
        SeikyuKei: seikyu,
        GenkaKei: genka_kingaku,
        ArariKei: arari,
        RiekiRitsu: !isNaN(arariritu) ? arariritu : 0,
      },
    ];
    subTotal.refresh();
  };

  // 明細の削除処理
  const handleOnClickDelete = (item) => (e) => {
    // 登録用の明細から削除
    editDetails.remove(item);
    // 見積基盤明細をリロード
    selectedKojiSyuBaseQuotes.refresh();
    // 合計を再計算
    calcTotal(referencePriceCheckBox.current.checked);
  };

  // 明細の移動処理
  const handleOnClickMove = (item, upDown) => (e) => {
    item = selectedRow;
    // 移動位置を取得
    let idx = editDetails.items.indexOf(item) + (upDown == 'down' ? 1 : -1);
    if (idx < 0) {
      return;
    }

    let _editDetails = editDetails.items.filter((x) => x != item);
    _editDetails.splice(idx, 0, item);
    editDetails.sourceCollection = _editDetails;
    editDetails.refresh();
  };

  // 登録明細の追加ボタン
  const handlenOnClickAdd = () => {
    const newItem = {
      BASE_NO: 0,
      QUOTE_KNO: quoteKbn.QUOTE_KNO,
      KOUJI_SYU: selectedKojiSyu,
      KINGAKU: 0,
      GENKA_RATE: 0,
      GENKA_KINGAKU: 0,
      EDITABLE_FLG: '1',
      BIKO_COLOR: '#000000',
      KOUJI_TYPE: 1,
    };

    // 選択行がある場合はその下に挿入、ない場合は末尾に追加
    const selectedIndex = editDetails.items.indexOf(selectedRow);
    if (selectedIndex !== -1) {
      const newItems = [...editDetails.items];
      newItems.splice(selectedIndex + 1, 0, newItem);
      editDetails.sourceCollection = newItems;
      editDetails.refresh();

      // 追加した行を選択状態にする
      setTimeout(() => {
        setSelectedRow(newItem);
        if (flexGrid.current) {
          const newIndex = selectedIndex + 1;
          flexGrid.current.select(new CellRange(newIndex, 0));
          flexGrid.current.scrollIntoView(newIndex, 0);
        }
      }, 0);
    } else {
      // 選択行がない場合は末尾に追加
      editDetails.addNew(newItem);
      editDetails.commitNew();
      setSelectedRow(newItem);
    }
  };

  // 工事種類の変更処理
  const handleChangeKojisyu = (target) => {
    // 工事種類の変更前と工事名称が同じもしくは工事名称が空の場合は連動して変更
    if (selectedKojiSyu == quoteKbn.KOUJI_DISPLAY_NAME || !quoteKbn.KOUJI_DISPLAY_NAME) {
      setQuoteKbn({ ...quoteKbn, KOUJI_DISPLAY_NAME: target.value });
    }
    setSelectedKojiSyu(target.value);
  };

  // 見積区分情報の編集処理
  const handleOnChangeQuoteKbn = (prop) => (target) => {
    setQuoteKbn({ ...quoteKbn, [prop]: target?.value ?? target?.target.value });
  };

  // 確定ボタン押下処理
  const handleOnClickFix = () => {
    // 工事種別が手入力が未入力の場合はエラー
    if (!quoteKbn.KOUJI_DISPLAY_NAME) {
      setTimeout(function () {
        setDialog({
          type: 'error',
          message: '工事名称を入力してください。',
        });
      }, 0);
      return;
    }

    props.callbackQuoteDetaiModal(
      editDetails.items.map((x, i) => ({
        ...x,
        KOUJI_SYU: selectedKojiSyu,
        QUOTE_KNO: quoteKbn.QUOTE_KNO,
        QUOTE_MNO: i + 1,
      })),
      {
        ...quoteKbn,
        KOUJI_SYU: selectedKojiSyu,
        TANKA: editDetails.items.reduce((a, x) => a + toFloat(x.KINGAKU), 0),
        TOTAL: editDetails.items.reduce((a, x) => a + toFloat(x.KINGAKU), 0),
        SU: 1,
        TANI: '式',
        GENKA_TOTAL: editDetails.items.reduce((a, x) => a + toFloat(x['GENKA_KINGAKU']), 0),
      }
    );
    handleClose();
  };

  // 閉じるボタン処理
  const handleClose = () => {
    // 入力値を初期値に戻す
    setSelectedKojiSyu('');
    selectedKojiSyuBaseQuotes.sourceCollection = [];
    editDetails.sourceCollection = [];
    props.setShow(false);
  };

  // グリッドのフォーマット処理
  const formatItemBase = (grid, e) => {
    if (e.panel.cellType == CellType.Cell) {
      var col = grid.columns[e.col];
      var dataItem = grid.rows[e.row].dataItem;

      const isSelectedBase = editDetails.items.some((x) => x.BASE_NO == dataItem.BASE_NO);
      e.cell.style.color = isSelectedBase ? 'blue' : '';
    }
  };

  // 見積基盤から明細を追加
  const addEditDeatailByBase = (dataItem) => {
    const newItem = {
      ...dataItem,
      QUOTE_KNO: quoteKbn.QUOTE_KNO,
      KINGAKU: calcItem(dataItem, 'KINGAKU'),
      GENKA_KINGAKU: calcItem(dataItem, 'GENKA_KINGAKU'),
      // 工事費パーセント(初期値は2:運搬諸経費は13%、1:工事費1~3%は1%)
      KOUJIHI_PER: dataItem.KOUJI_TYPE == 2 ? 13 : dataItem.KOUJI_TYPE == 3 ? 1 : 0,
    };

    // 選択行がある場合はその下に挿入、ない場合は末尾に追加
    if (selectedRow !== -1) {
      const selectedIndex = editDetails.items.indexOf(selectedRow);
      if (selectedIndex !== -1) {
        const newItems = [...editDetails.items];
        // selectedIndex + 1 の位置に挿入することで、選択行の「下」に追加される
        newItems.splice(selectedIndex + 1, 0, newItem);
        editDetails.sourceCollection = newItems;
        editDetails.refresh();

        // 追加した行を選択状態にする
        setTimeout(() => {
          setSelectedRow(newItem);
          // グリッドの選択も更新
          if (flexGrid.current) {
            const newIndex = selectedIndex + 1;
            flexGrid.current.select(new CellRange(newIndex, 0));
            flexGrid.current.scrollIntoView(newIndex, 0);
          }
        }, 0);
      } else {
        // 選択行が見つからない場合は末尾に追加
        editDetails.addNew(newItem);
        editDetails.commitNew();
        setSelectedRow(newItem);
      }
    } else {
      // 選択行がない場合は末尾に追加
      editDetails.addNew(newItem);
      editDetails.commitNew();
      setSelectedRow(newItem);
    }

    selectedKojiSyuBaseQuotes.refresh();
    // 合計を再計算
    calcTotal(referencePriceCheckBox.current.checked);
  };

  // 貼り付け処理（編集開始処理をおこなう）
  const pastingCell = (s, args) => {
    beginningEdit(s, args);
  };
  // 編集開始処理
  const beginningEdit = (grid, args) => {
    var dataItem = grid.rows[args.row].dataItem;
    var col = grid.columns[args.col];

    // 注文済の場合は非活性
    if (dataItem?.CYU_MNO_KEY) {
      args.cancel = true;
    }
    // 見積基盤から選択した項目の場合
    else if (dataItem && dataItem['BASE_NO']) {
      // 工事種、内容、金額、原価金額は編集不可
      var readOnlys = ['KOUJI_SYU', 'CONTENT', 'KINGAKU', 'GENKA_KINGAKU'];
      // 仕様、単位、単価、掛け率、原価単価はフラグが編集可能フラグがOFFの場合は編集不可
      if (dataItem['EDITABLE_FLG'] != '1') {
        readOnlys = [...readOnlys, 'SIYOU', 'TANI', 'TANKA', 'GENKA_RATE', 'GENKA_TANKA'];
      }
      // 工事種類が1:通常でない場合（パーセント表示の場合）単価、金額、数量
      if (dataItem.KOUJI_TYPE != 1) {
        readOnlys = [...readOnlys, 'SU', 'SIYOU', 'TANI', 'TANKA', 'GENKA_RATE', 'GENKA_TANKA'];
      } else {
        // 工事種類が1:通常はパーセントの入力は不可
        readOnlys = [...readOnlys, 'KOUJIHI_PER'];
      }
      // 手入力時、単価を編集可能にする
      if (dataItem['KOUJIHI_PER'] > 100) {
        readOnlys = readOnlys.filter((item) => item !== 'TANKA');
      }

      if (readOnlys.includes(col['binding'])) {
        args.cancel = true;
      }
    }
    // 手動の場合は以下を入力不可
    else {
      var readOnlys = ['KOUJI_SYU', 'KINGAKU', 'GENKA_KINGAKU'];
      if (readOnlys.includes(col['binding'])) {
        args.cancel = true;
      }
    }
  };

  // グリッドの選択時の処理（ime制御)
  const gridSelectionChanged = (grid, args) => {
    var col = grid.columns[args.col];
    // 数量、単価、原価、掛け率の場合はimeをoffにする
    var imeEnabled = !['SU', 'TANKA', 'GENKA_TANKA', 'GENKA_RATE'].some((x) => x == col?.binding);
    setTimeout(function () {
      grid.imeEnabled = imeEnabled;
    }, 50);
  };

  // 貼り付け後の処理
  const pasted = (grid, args) => {
    cellEditEnded(grid, args);
  };
  // 編集終了処理
  const cellEditEnded = (grid, args) => {
    var dataItem = grid.rows[args.row].dataItem;
    var col = grid.columns[args.col];
    var upd = false;
    // 掛け率から原価を計算
    if (col['binding'] == 'GENKA_RATE') {
      let tanka = toFloat(dataItem['TANKA']);
      let rate = toFloat(dataItem['GENKA_RATE'], 2);

      dataItem['GENKA_RATE'] = rate;
      dataItem['GENKA_TANKA'] = toInt(new Big(rate).times(tanka));
      dataItem['GENKA_KINGAKU'] = calcItem(dataItem, 'GENKA_KINGAKU');
      upd = true;
    }
    // 単価/原価単価から掛け率を取得
    else if (col['binding'] == 'TANKA' || col['binding'] == 'GENKA_TANKA') {
      let genka = toFloat(dataItem['GENKA_TANKA']);
      let tanka = toFloat(dataItem['TANKA']);
      let rate = tanka == 0 ? 0 : genka / tanka;

      rate = !isNaN(rate) ? rate : 0;
      dataItem['GENKA_RATE'] = toFloat(rate, 2);
      dataItem['GENKA_KINGAKU'] = calcItem(dataItem, 'GENKA_KINGAKU');

      upd = true;
    }
    // 数量の場合は小数点第二位で切り捨て
    else if (col['binding'] == 'SU') {
      dataItem['SU'] = toFloat(dataItem['SU'], 2);
      dataItem['KINGAKU'] = calcItem(dataItem, 'KINGAKU');
      dataItem['GENKA_KINGAKU'] = calcItem(dataItem, 'GENKA_KINGAKU');
      upd = true;
    }
    // 工事費パーセンテージ
    else if (col['binding'] == 'KOUJIHI_PER') {
      // 合計の算出処理で再計算するのでここではフラグだけ
      upd = true;
    }

    // 一覧の再描画をおこなう
    if (upd) {
      // 合計を計算
      calcTotal(referencePriceCheckBox.current.checked);
    }
  };

  // グリッドのフォーマット処理
  const formatItem = (grid, e) => {
    if (e.panel.cellType == CellType.Cell) {
      var col = grid.columns[e.col];
      var dataItem = grid.rows[e.row].dataItem;

      // 注文済の場合は非活性
      if (dataItem?.CYU_MNO_KEY) {
        e.cell.style.background = 'rgb(236, 219, 219)';
      }

      // 見積基盤の場合は以下を非活性
      else if (dataItem['BASE_NO'] != 0) {
        // 工事種、内容、金額、原価金額は編集不可
        var readOnlys = ['KOUJI_SYU', 'CONTENT', 'KINGAKU', 'GENKA_KINGAKU'];
        // 仕様、単位、単価、掛け率、原価単価はフラグが編集可能フラグがOFFの場合は編集不可
        if (dataItem['EDITABLE_FLG'] != '1') {
          readOnlys = [...readOnlys, 'SIYOU', 'TANI', 'TANKA', 'GENKA_RATE', 'GENKA_TANKA'];
        }
        // 工事種類が1:通常でない場合（パーセント表示の場合）単価、金額、数量
        if (dataItem.KOUJI_TYPE != 1) {
          readOnlys = [...readOnlys, 'SU', 'SIYOU', 'TANI', 'TANKA', 'GENKA_RATE', 'GENKA_TANKA'];
        } else {
          // 工事種類が1:通常はパーセントの入力は不可
          readOnlys = [...readOnlys, 'KOUJIHI_PER'];
        }

        // 手入力時、単価を編集可能にする
        if (dataItem['KOUJIHI_PER'] > 100) {
          readOnlys = readOnlys.filter((item) => item !== 'TANKA');
        }

        if (readOnlys.includes(col['binding'])) {
          e.cell.style.background = 'rgb(236, 219, 219)';
        } else {
          e.cell.style.background = '';
        }
      }
      // 手動の場合は以下を非活性
      else {
        var readOnlys = ['KOUJI_SYU', 'KINGAKU', 'GENKA_KINGAKU'];
        if (readOnlys.includes(col['binding'])) {
          e.cell.style.background = 'rgb(236, 219, 219)';
        } else {
          e.cell.style.background = '';
        }
      }

      // 備考の場合はフォントカラーを修正
      if (col['binding'] == 'BIKO') {
        e.cell.style.color = dataItem.BIKO_COLOR;
      }

      // 金額
      if (col['binding'] == 'KINGAKU') {
        dataItem['KINGAKU'] = calcItem(dataItem, 'KINGAKU');
      }

      // 原価合計
      if (col['binding'] == 'GENKA_KINGAKU') {
        dataItem['GENKA_KINGAKU'] = calcItem(dataItem, 'GENKA_KINGAKU');
      }
    }
  };

  // 計算処理
  const calcItem = (dataItem, prop) => {
    // 金額 = 数量 * 単価
    if (prop == 'KINGAKU') {
      let tanka = toFloat(dataItem['TANKA']);
      let su = toFloat(dataItem['SU'], 2);
      return toInt(tanka * su);
    }
    // 原価合計 = 数量 * 原価
    if (prop == 'GENKA_KINGAKU') {
      let genka = toFloat(dataItem['GENKA_TANKA']);
      let su = toFloat(dataItem['SU'], 2);
      return toInt(genka * su);
    }
  };

  // 見積もり明細の選択処理
  const selectionChanged = (item) => (e) => {
    setSelectedRow(item);
  };

  // 色選択ダイアログパラメタ
  const [colorPickerParams, setColorPickerParams] = useState({});

  // 色の変更処理（ヘッダ）
  const handleOnClickHeaderColor = (e) => {
    let mode = 'font';
    let backColor = '#ffffff';
    let fontColor = quoteKbn?.BIKO_COLOR;
    setColorPickerParams({
      color: fontColor,
      mode: mode,
      backColor: backColor,
      fontColor: fontColor,
      callBack: (_color) => {
        setQuoteKbn({ ...quoteKbn, BIKO_COLOR: _color });
      },
    });
    e.preventDefault();
  };

  // 色の変更処理（明細）
  const handleOnClickColor = (e, cell, color) => {
    let mode = 'font';
    let backColor = '#ffffff';
    let fontColor = color;

    setColorPickerParams({
      color: color,
      mode: mode,
      backColor: backColor,
      fontColor: fontColor,
      callBack: (_color) => {
        Object.assign(editDetails.items[cell.row.index], { ...cell.item, BIKO_COLOR: _color });
        editDetails.refresh();
      },
    });
    e.preventDefault();
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        open={props.show}
        sx={{
          '& .MuiDialog-container': {
            alignItems: 'flex-start',
            '& .MuiPaper-root': {
              maxWidth: 'calc(100vw - 180px)',
              height: 'calc(100vh - 65px)',
              marginTop: '20px',
            },
          },
        }}
        disableEnforceFocus={true} // フォーカス制御を無効にする
      >
        <DialogTitle className="p-3">
          {isAddInvoice ? '追加請求明細登録' : '見積明細登録'}
        </DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <Card className="m-0">
            <Card.Body>
              <Row>
                <Col className="pl-3" md="2">
                  <Form.Group>
                    <label>工事種別</label>
                    <SelectComponent value={selectedKojiSyu} onChange={handleChangeKojisyu}>
                      {kojiSyuList.map((x, i) => (
                        <option key={i} value={x}>
                          {x}
                        </option>
                      ))}
                    </SelectComponent>
                  </Form.Group>
                </Col>
                <Col className="pl-3" md="4">
                  <Form.Group>
                    <label>工事名称</label>
                    <TextComponent
                      placeholder="工事名称を入力してください"
                      type="text"
                      value={quoteKbn?.KOUJI_DISPLAY_NAME}
                      onChange={handleOnChangeQuoteKbn('KOUJI_DISPLAY_NAME')}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col className="pl-3" md="3">
                  <label>　</label>
                  <div style={{ display: 'flex', alignItems: 'end' }}>
                    <label className="mr-2 mt-1" style={{ fontSize: '14pt', color: 'black' }}>
                      <input
                        ref={referencePriceCheckBox}
                        className="mr-2"
                        style={{ transform: 'scale(1.5)' }}
                        type="checkbox"
                        checked={quoteKbn?.REFERNCE_PRICE == 1}
                        onChange={(e) => {
                          setQuoteKbn({ ...quoteKbn, REFERNCE_PRICE: e.target.checked ? 1 : 0 });
                          calcTotal(e.target.checked);
                        }}
                      ></input>
                      別途参考価格
                    </label>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={6} className=" pr-0">
                  <Form.Group>
                    <label>仕様</label>
                    <TextComponent
                      type="text"
                      value={quoteKbn?.SIYOU}
                      onChange={handleOnChangeQuoteKbn('SIYOU')}
                    ></TextComponent>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <label style={{ marginRight: '10px' }}>備考</label>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TextComponent
                        type="text"
                        value={quoteKbn?.BIKO}
                        onChange={handleOnChangeQuoteKbn('BIKO')}
                        color={quoteKbn?.BIKO_COLOR}
                      />
                      <input
                        className="ml-1"
                        type="color"
                        style={{ width: '28px', marginLeft: '10px' }}
                        value={quoteKbn?.BIKO_COLOR}
                        onClick={(e) => handleOnClickHeaderColor(e)}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col className="pt-2 pl-3 table-scroll" md="12" style={{ height: '200px' }}>
                  <FlexGrid
                    className="quote-grid"
                    allowSorting={false}
                    itemsSource={selectedKojiSyuBaseQuotes}
                    selectionMode={'Cell'}
                    headersVisibility={'Column'}
                    formatItem={formatItemBase}
                    ref={baseGridRef}
                    initialized={(grid) => {
                      baseGridRef.current = grid;
                      grid.rowHeight = 80;
                      grid.keyActionEnter = KeyAction.None;
                      grid._cleanupKeydown && grid._cleanupKeydown();

                      const onKeyDown = (e) => {
                        if (e.isComposing || e.nativeEvent?.isComposing) return;
                        if (e.key === 'Tab') {
                          e.preventDefault();
                          const lower = flexGrid.current;
                          if (!lower) return;
                          grid.finishEditing(true);
                          grid.selection = new CellRange(-1, -1); // 選択クリア
                          grid.hostElement?.blur();
                          const firstEditableCol = Math.max(
                            0,
                            (lower.columns || []).findIndex(c => !c.isReadOnly)
                          );
                          if (lower.rows?.length) {
                            lower.selection = new CellRange(0, firstEditableCol);
                          }
                          requestAnimationFrame(() => {
                            lower.hostElement?.focus();
                            lower.startEditing(false);
                          });
                          return;
                        }
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          e.stopPropagation();

                          const r = grid.selection?.row ?? -1;
                          if (r < 0 || r >= (grid.rows?.length ?? 0)) return;
                          suppressNextClickRef.current = true;

                          const item = grid.rows[r].dataItem;
                          addEditDeatailByBase(item);

                          const next = Math.min(r + 1, grid.rows.length - 1);
                          grid.selection = new CellRange(next, 0);
                          grid.scrollIntoView(next, 0);

                          requestAnimationFrame(() => {
                            grid.hostElement?.focus();
                            suppressNextClickRef.current = false;
                          });
                        }
                      };
                      grid.hostElement.addEventListener('keydown', onKeyDown, true);
                      grid._cleanupKeydown = () =>
                        grid.hostElement.removeEventListener('keydown', onKeyDown, true);
                    }}
                  >
                    <FlexGridColumn header="" width={28} isReadOnly={true}>
                      <FlexGridCellTemplate
                        cellType="Cell"
                        template={(cell) => (
                          <IconButtonCompnent
                            className="cell-icon-sm"
                            variant="primary"
                            title="追加"
                            onClick={(ev) => {
                              if (suppressNextClickRef.current) {
                                ev.preventDefault();
                                ev.stopPropagation();
                                return;
                              }
                              addEditDeatailByBase(cell.item);
                            }}
                            icon="Playlist_Add"
                          ></IconButtonCompnent>
                        )}
                      />
                    </FlexGridColumn>
                    <FlexGridColumn
                      binding="CONTENT"
                      header="名称"
                      width={200}
                      isReadOnly={true}
                      cssClass="cell-readonly"
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="SIYOU"
                      header="仕様"
                      width={200}
                      isReadOnly={true}
                      cssClass="cell-readonly"
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="TANI"
                      header="単位"
                      isReadOnly={true}
                      cssClass="cell-readonly"
                      width={50}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="TANKA"
                      header="単価"
                      isReadOnly={true}
                      cssClass="cell-readonly"
                      dataType="Number"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="BIKO"
                      header="備考"
                      isReadOnly={true}
                      cssClass="cell-readonly"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="GENKA_RATE"
                      header="掛け率"
                      sReadOnly={true}
                      cssClass="cell-readonly"
                      format="n2"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="GENKA_TANKA"
                      header="原価単価"
                      isReadOnly={true}
                      cssClass="cell-readonly"
                      dataType="Number"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="BIKO_SYANAI"
                      header="社内備考"
                      isReadOnly={true}
                      cssClass="cell-readonly"
                      width="2*"
                      allowResizing={false}
                      aggregate="Sum"
                    ></FlexGridColumn>
                  </FlexGrid>
                </Col>
              </Row>
              <Row className="pt-2">
                <Col>
                  <Button
                    className="material-symbols-rounded cell-icon-sm btn-fill"
                    variant="success"
                    disabled={editDetails.items.indexOf(selectedRow) < 0}
                    title="下に移動"
                    onClick={handleOnClickMove({}, 'down')}
                  >
                    Arrow_Downward
                  </Button>
                  <Button
                    className="material-symbols-rounded cell-icon-sm btn-fill ml-1"
                    variant="success"
                    disabled={editDetails.items.indexOf(selectedRow) < 0}
                    title="上に移動"
                    onClick={handleOnClickMove({}, 'up')}
                  >
                    Arrow_Upward
                  </Button>
                </Col>
                <Col className="text-right">
                  <Button
                    className="material-symbols-rounded cell-icon-sm btn-fill"
                    title="追加"
                    onClick={handlenOnClickAdd}
                  >
                    add
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col className="pt-1 pl-3 table-scroll" md="12" style={{ height: '295px' }}>
                  <FlexGrid
                    className="quote-grid"
                    imeEnabled={true}
                    ref={flexGrid}
                    allowSorting={false}
                    itemsSource={editDetails}
                    selectionMode={'Cell'}
                    headersVisibility={'Column'}
                    formatItem={formatItem}
                    beginningEdit={beginningEdit}
                    cellEditEnded={cellEditEnded}
                    pastingCell={pastingCell}
                    pasted={pasted}
                    keyActionTab={KeyAction.Cycle}
                    autoGenerateColumns={false}
                    selectionChanged={gridSelectionChanged}
                    initialized={(g) => {
                      flexGrid.current = g;
                      // Shift+Tab ハンドラ（先頭セル→上グリッドの左端へ）
                      const onKeyDown = (e) => {
                        if (e.key === 'Tab' && e.shiftKey) {
                          const sel = g.selection;
                          if (!sel) return;
                          const atFirstRow = sel.row === 0;
                          const atLeftEdge = sel.col === 0;

                          if (atFirstRow && atLeftEdge) {
                            e.preventDefault();
                            e.stopPropagation();
                            g.finishEditing(true);
                            g.selection = new CellRange(-1, -1); // ハイライト消す
                            g.hostElement?.blur(); // wj-state-focused を外す
                            const upper = baseGridRef.current;
                            if (upper) {
                              // 上グリッドの、現在の選択行（なければ0行目）× 左端列へ
                              const targetRow = Math.max(0, upper.selection?.row ?? 0);
                              upper.selection = new CellRange(targetRow, 0);
                              upper.scrollIntoView(targetRow, 0);
                              upper.hostElement?.focus();
                            }
                          }
                        }
                      };
                      g.hostElement.addEventListener('keydown', onKeyDown, true);
                      g._cleanupShiftTab && g._cleanupShiftTab();
                      g._cleanupShiftTab = () => g.hostElement.removeEventListener('keydown', onKeyDown, true);
                    }}
                  >
                    <FlexGridColumn header="　" isReadOnly={true} width={28}>
                      <FlexGridCellTemplate
                        cellType="Cell"
                        template={(cell) => (
                          <input
                            type="radio"
                            checked={cell.item === selectedRow}
                            onClick={selectionChanged(cell.item)}
                          ></input>
                        )}
                      />
                    </FlexGridColumn>
                    <FlexGridColumn
                      binding="CONTENT"
                      header="名称"
                      width={200}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="SIYOU"
                      header="仕様"
                      width={200}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="SU"
                      header="数量"
                      dataType="Number"
                      format="n2"
                      width={100}
                      inputType={'tel'}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="TANI"
                      header="単位"
                      width={50}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="KOUJIHI_PER"
                      header="％"
                      width={60}
                      dataMap={persentMap}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="TANKA"
                      header="単価"
                      dataType="Number"
                      width={100}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="KINGAKU"
                      header="金額"
                      dataType="Number"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="BIKO"
                      header="備考"
                      width={100}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn binding="BIKO_COLOR" header="色" width={28}>
                      <FlexGridCellTemplate
                        cellType="Cell"
                        template={(cell) => (
                          <input
                            className="p-0"
                            type="color"
                            style={{ width: '21px', height: '21px' }}
                            value={cell.item.BIKO_COLOR}
                            onClick={(e) => handleOnClickColor(e, cell, cell.item.BIKO_COLOR)}
                          />
                        )}
                      />
                    </FlexGridColumn>
                    <FlexGridColumn
                      binding="GENKA_RATE"
                      header="掛け率"
                      width={100}
                      format="n2"
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="GENKA_TANKA"
                      header="原価単価"
                      dataType="Number"
                      width={100}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="GENKA_KINGAKU"
                      header="原価合計"
                      dataType="Number"
                      width={100}
                    ></FlexGridColumn>
                    <FlexGridColumn
                      binding="BIKO_SYANAI"
                      header="社内備考"
                      width="2*"
                      allowResizing={false}
                      isRequired={false}
                    ></FlexGridColumn>
                    <FlexGridColumn header="　" isReadOnly={true} width={28}>
                      <FlexGridCellTemplate
                        cellType="Cell"
                        template={(cell) => (
                          <IconButtonCompnent
                            className="cell-icon-sm"
                            variant="danger"
                            title="削除"
                            onClick={handleOnClickDelete(cell.item)}
                            disabled={cell.item.CYU_MNO_KEY}
                            tooltip={cell.item.CYU_MNO_KEY ? '注文済みのため、削除できません' : ''}
                            icon="Clear"
                          ></IconButtonCompnent>
                        )}
                      />
                    </FlexGridColumn>
                  </FlexGrid>
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {/** 確認ダイアログ */}
          <MessageModal dialog={dialog}></MessageModal>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>

          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ButtonGroup className="mr-2">
              <Button
                variant="secondary"
                className={`p-1  ${totalMode == 'detail' ? 'btn-fill' : ''}`}
                onClick={() => {
                  setTotalMode('detail');
                }}
                style={{ width: 80, height: 32 }}
              >
                明細別
              </Button>
              <Button
                variant="secondary"
                className={`p-1  ${totalMode == 'all' ? 'btn-fill' : ''}`}
                onClick={() => {
                  setTotalMode('all');
                }}
                style={{ width: 80, height: 32 }}
              >
                全体
              </Button>
            </ButtonGroup>

            <div style={{ width: '920px', display: totalMode == 'detail' ? 'none' : '' }}>
              <FlexGrid
                itemsSource={total}
                selectionMode={'None'}
                headersVisibility={'Column'}
                autoGenerateColumns={false}
                isReadOnly={true}
                allowSorting={false}
              >
                <FlexGridColumn
                  binding="Koujihi"
                  header="工事費"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ShoKei"
                  header="小計"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="Nebiki"
                  header="特別割引"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="Zeinuki"
                  header="税別合計"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ZeiKei"
                  header="消費税"
                  format="c0"
                  width={90}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="SeikyuKei"
                  header="請求金額"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="GenkaKei"
                  header="原価合計"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ArariKei"
                  header="粗利益額"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="RiekiRitsu"
                  header="利益率"
                  format="p1"
                  width={80}
                ></FlexGridColumn>
              </FlexGrid>
            </div>
            <div style={{ width: '920px', display: totalMode == 'all' ? 'none' : '' }}>
              <FlexGrid
                itemsSource={subTotal}
                selectionMode={'None'}
                headersVisibility={'Column'}
                autoGenerateColumns={false}
                isReadOnly={true}
                allowSorting={false}
              >
                <FlexGridColumn
                  binding="Koujihi"
                  header="工事費"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ShoKei"
                  header="小計"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ZeiKei"
                  header="消費税"
                  format="c0"
                  width={90}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="SeikyuKei"
                  header="請求金額"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="GenkaKei"
                  header="原価合計"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="ArariKei"
                  header="粗利益額"
                  format="c0"
                  width={'1*'}
                ></FlexGridColumn>
                <FlexGridColumn
                  binding="RiekiRitsu"
                  header="利益率"
                  format="p1"
                  width={80}
                ></FlexGridColumn>
              </FlexGrid>
            </div>
          </div>
          <Button
            className="btn-fill footer-button"
            variant="primary"
            disabled={isFixButtonDisabled}
            onClick={handleOnClickFix}
          >
            確定
          </Button>
        </DialogActions>
      </Dialog>

      {/** カラーピッカー */}
      <ColorPickerModal params={colorPickerParams}></ColorPickerModal>
    </>
  );
}

export default QuoteBaseModal;